var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepartmentFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 18.5,
    fill: "#E7E5E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 25.6668H12.3332M12.3332 25.6668H21.4998M12.3332 25.6668V20.9735C12.3332 20.536 12.3332 20.3168 12.3857 20.1127C12.4329 19.9304 12.5084 19.761 12.6123 19.6043C12.729 19.4293 12.8923 19.2818 13.2182 18.9902L15.1357 17.2668C15.7648 16.7018 16.079 16.4193 16.4357 16.3118C16.7493 16.2173 17.0837 16.2173 17.3973 16.3118C17.754 16.4193 18.069 16.7018 18.699 17.2677L20.6157 18.9902C20.9407 19.2818 21.1032 19.4293 21.2207 19.6043C21.324 19.7602 21.4007 19.9318 21.4473 20.1127C21.4998 20.3168 21.4998 20.536 21.4998 20.9735V25.6668M21.4998 25.6668H25.6665M25.6665 25.6668H27.3332M25.6665 25.6668V14.9977C25.6665 14.066 25.6665 13.5993 25.4848 13.2435C25.3248 12.9298 25.0696 12.6748 24.7557 12.5152C24.3998 12.3335 23.9332 12.3335 22.9998 12.3335H17.4998C16.5665 12.3335 16.0998 12.3335 15.7432 12.5152C15.4296 12.6749 15.1746 12.9299 15.0148 13.2435C14.8332 13.6002 14.8332 14.0668 14.8332 15.0002V17.3335",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartmentFrame);
export default __webpack_public_path__ + "static/media/DepartmentFrame.a5e7708d74e7a3ed8da71272656a386c.svg";
export { ForwardRef as ReactComponent };